import moment from 'moment'
import 'moment/min/locales'

var momentSettings = {
  months : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  monthsShort : ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  weekdays : ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  weekdaysShort : ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  weekdaysMin : ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
}

moment.updateLocale('pl', momentSettings);
moment.updateLocale('de', momentSettings);